export default "__VITE_PUBLIC_ASSET__7ab286ee__"